import React from "react"
import { Drawer, DrawerProps, styled } from "@mui/material"

export const AsideComponent = styled((props: DrawerProps) => (
  <Drawer anchor="left" elevation={0} hideBackdrop {...props}>
    {props.children}
  </Drawer>
))(({ theme: { breakpoints, palette } }) => ({
  "&.MuiDrawer-root": {
    [breakpoints.down("lg")]: {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      background: palette.aside.main,
    },
    [breakpoints.up("lg")]: {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      background: palette.aside.background,
    },
  },
  ".MuiDrawer-paper": {
    color: palette.common.white,
    [breakpoints.down("lg")]: {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      background: palette.aside.main,
    },
    [breakpoints.up("lg")]: {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      background: palette.aside.background,
    },
  },
}))
